import { render, staticRenderFns } from "./AIcons.vue?vue&type=template&id=6ba7f0a7&"
import script from "./AIcons.vue?vue&type=script&lang=js&"
export * from "./AIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon})
